"use client";

import React from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import {
	Stack,
	Typography,
	TextField,
	InputAdornment,
	inputBaseClasses,
} from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { RHFInputDecimalField } from "@onair/ui/form-controls/input-decimal";

import { WizardSchemaType } from "../index";

interface PropTypes {
	methods: UseFormReturn<WizardSchemaType>;
	index: number;
}

const EventSessionPricingForm: React.FC<PropTypes> = ({ methods, index }) => {
	const { unregister, setValue, getValues, control } = methods;

	const isUnlimitedAudiences = useWatch({
		name: `stepPricing.sessions.${index}.ticketTiers.0.isUnlimitedAudiences`,
		control,
	});
	const isFree = useWatch({
		name: `stepPricing.sessions.${index}.ticketTiers.0.isFree`,
		control,
	});
	const hasBeenPaid = getValues(
		`stepPricing.sessions.${index}.ticketTiers.0.hasBeenPaid`,
	);

	React.useEffect(() => {
		if (isFree) {
			unregister(`stepPricing.sessions.${index}.ticketTiers.0.farePrice`);
			setValue(`stepPricing.sessions.${index}.ticketTiers.0.farePrice`, 0);
		}

		if (isUnlimitedAudiences) {
			setValue(
				`stepPricing.sessions.${index}.ticketTiers.0.limitAudiences`,
				undefined,
				{
					shouldValidate: true,
				},
			);
		}
	}, [isFree, isUnlimitedAudiences]);

	return (
		<Stack spacing={3}>
			<Stack spacing={1}>
				<Field.Switch
					name={`stepPricing.sessions.${index}.ticketTiers.0.isUnlimitedAudiences`}
					label={
						<Typography fontWeight={600} variant="body2">
							Không giới hạn sức chứa
						</Typography>
					}
				/>
				{isUnlimitedAudiences ? (
					<TextField
						label="Số người đăng ký"
						required
						value="Không giới hạn"
						disabled
						sx={{
							[`& .${inputBaseClasses.root}`]: {
								backgroundColor: "white",
							},
						}}
					/>
				) : (
					<RHFInputDecimalField
						name={`stepPricing.sessions.${index}.ticketTiers.0.limitAudiences`}
						label="Số người đăng ký"
						required
						sx={{
							[`& .${inputBaseClasses.root}`]: {
								backgroundColor: "white",
							},
						}}
					/>
				)}
			</Stack>
			<Stack spacing={1}>
				<Field.Switch
					name={`stepPricing.sessions.${index}.ticketTiers.0.isFree`}
					disabled={hasBeenPaid}
					label={
						<Typography fontWeight={600} variant="body2">
							Vé miễn phí
						</Typography>
					}
				/>
				<RHFInputDecimalField
					disabled={isFree || hasBeenPaid}
					label="Giá vé"
					required
					name={`stepPricing.sessions.${index}.ticketTiers.0.farePrice`}
					InputProps={{
						endAdornment: <InputAdornment position="end"> ₫</InputAdornment>,
					}}
					sx={{
						flex: 1,
						textAlign: "right",
						[`& .${inputBaseClasses.root}`]: {
							backgroundColor: "white",
						},
					}}
				/>
			</Stack>
		</Stack>
	);
};

export default EventSessionPricingForm;
